// 根据角色动态生成路由
import { defineFakeRoute } from "vite-plugin-fake-server/client"

export default defineFakeRoute([
  {
    url: "/login",
    method: "post",
    response: ({ body }) => {
      if (body.role === 1) {
        return {
          success: true,
          data: {
            avatar: "https://avatars.githubusercontent.com/u/67857649?v=4",
            username: "admin",
            nickname: "Mophar",
            // 一个用户可能有多个角色
            roles: ["admin"],
            accessToken: "eyJhbGciOiJIUzUxMiJ9.admin",
            refreshToken: "eyJhbGciOiJIUzUxMiJ9.adminRefresh",
            expires: "2030/10/30 00:00:00"
          }
        }
      } else {
        return {
          success: true,
          data: {
            avatar: "https://avatars.githubusercontent.com/u/52823142",
            username: "student",
            nickname: "老李",
            roles: ["student"],
            accessToken: "eyJhbGciOiJIUzUxMiJ9.student",
            refreshToken: "eyJhbGciOiJIUzUxMiJ9.studentRefresh",
            expires: "2030/10/30 00:00:00"
          }
        }
      }
    }
  }
])
